import { Outlet } from "react-router-dom";
import {
  AdminMobileHeader,
  AdminSidebar,
  useAdminSidebarState,
} from "../components/admin/AdminSidebar";
import { AdminWorkspaceProvider } from "../contexts/AdminWorkspaceProvider";

function AdminLayoutContent() {
  const { collapsed, setCollapsed, mobileOpen, setMobileOpen } =
    useAdminSidebarState();

  return (
    <div className="min-h-screen">
      <AdminSidebar
        collapsed={collapsed}
        mobileOpen={mobileOpen}
        onCollapsedChange={setCollapsed}
        onMobileOpenChange={setMobileOpen}
      />
      <div
        className={[
          "min-h-screen transition-[padding] duration-200",
          collapsed ? "lg:pl-[4.5rem]" : "lg:pl-64",
        ].join(" ")}
      >
        <AdminMobileHeader onOpen={() => setMobileOpen(true)} />
        <Outlet />
      </div>
    </div>
  );
}

export default function AdminLayout() {
  return (
    <AdminWorkspaceProvider>
      <AdminLayoutContent />
    </AdminWorkspaceProvider>
  );
}
